import React, { useState, useEffect, useRef, useCallback } from 'react';

const COUNTERS = {};
const SELFS = {};
const STATE = {};

function storage(WrappedComponent, keyState, defParams = {}) {
    const Storage = (props) => {
        const [updateCounter, setUpdateCounter] = useState(0);
        const indexRef = useRef(null);
        const mountedRef = useRef(true);

        if (!STATE[keyState]) {
            STATE[keyState] = { ...defParams };
            SELFS[keyState] = {};
            COUNTERS[keyState] = 0;
        }

        if (indexRef.current === null) {
            indexRef.current = COUNTERS[keyState];
            SELFS[keyState][indexRef.current] = { forceUpdate: () => setUpdateCounter(prev => prev + 1) };
            COUNTERS[keyState] += 1;
        }

        useEffect(() => {
            mountedRef.current = true;
            return () => {
                mountedRef.current = false;
                if (indexRef.current !== null) {
                    delete SELFS[keyState][indexRef.current];
                    if (!Object.keys(SELFS[keyState]).length) {
                        delete STATE[keyState];
                        COUNTERS[keyState] = 0;
                    }
                }
            };
        }, []);

        const setStorage = useCallback((data) => {
            if (!mountedRef.current) return;
            
            for (let k in data) STATE[keyState][k] = data[k];
            for (let k in SELFS[keyState]) {
                if (SELFS[keyState][k] && typeof SELFS[keyState][k].forceUpdate === 'function') {
                    SELFS[keyState][k].forceUpdate();
                }
            }
        }, [keyState]);

        return (
            <WrappedComponent
                {...props}
                {...STATE[keyState]}
                setStorage={setStorage}
            />
        );
    };

    Storage.displayName = `Storage(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return Storage;
}

export default storage;
